<template>
  <b-card class="rounded-xl">
    <!-- <div>
      <b-modal title="View Details" id="isViewDetails" width="30%">
        <ViewProfile />
      </b-modal>
    </div> -->
    <editRole
      :editRole="editRole"
      @close-editRole="toggleEditRole"
      :edit_role="edit_role"
      :singleUserData="singleUserData"
    />
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT IMAGE ORDER
      </h6>
      <EditCategoryDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>

    <InfoForm
      :isActive="editformModal"
      @close="editformModal = false"
      :userData="userData"
    />

    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Users</h2>
      </div>
      <div class="flex">
        <base-button outline type="primary" class="flex px-6 py-1 mx-1">
          <download-excel
            class="mr-1 flex"
            default-value=""
            :fetch="fetchData"
            :fields="json_fields"
            worksheet="My Worksheet"
            name="Excelfile.xls"
          >
            <!-- <feather-icon icon="PlusIcon" class="mr-1"></feather-icon> -->
            <!-- :fetch="fetchData" -->

            <feather-icon icon="UploadIcon" class="mr-2 cust-HW"></feather-icon
            >Export
          </download-excel>
        </base-button>

        <!-- <base-button outline type="primary" class="flex px-6 py-1 mx-1">
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon> Export
        </base-button> -->
        <!-- <base-button
          outline
          type="primary"
          class="flex px-6 py-1 mx-1"
          @click="addBanner"
        >
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon> Import
          Users
        </base-button> -->
      </div>
    </div>
    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
        v-model="search"
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
          @click="getUsers"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="user.result"
      border
    >
      <el-table-column label="Name" prop="name" min-width="140px">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            row.firstname + " " + row.lastname
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Phone" min-width="150px" prop="phone">
        <template v-slot="{ row }">
          <!-- {{ row }} -->
          <span class="text-black font-medium">{{ row.mobile }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Email" min-width="200px" prop="email">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.email }}</span>
        </template>
      </el-table-column>

      <el-table-column label="User Type" min-width="120px" prop="usertype">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            row.role == "student" ? "Registered user" : row.role
          }}</span>
          <!-- <feather-icon
            icon="EditIcon"
            class="font-semibold cursor-pointer icon18px"
            v-b-modal="editRole"
            @click.stop="edit_role(row)"
          ></feather-icon> -->
        </template>
      </el-table-column>

      <el-table-column label="Created At" min-width="130px" prop="createdat">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            new Date(row.createdAt).toDateString()
          }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Karuna Points" min-width="120px" prop="usertype">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            row.karmaPoint.length
              ? row.karmaPoint[0].amount
                ? row.karmaPoint[0].amount
                : "0"
              : "0"
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="Session Details" min-width="130px" prop="details">
        <template>
          <p
            @click="handleClick('session-details')"
            class="underline cursor-pointer"
          >
            view details
          </p>
        </template>
      </el-table-column> -->
      <el-table-column label="Details" min-width="130px" prop="details">
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{ row.details }}</span>
          <p
            class="underline cursor-pointer"
            @click="handleRoute('view-profile', row)"
          >
            view details
          </p>
        </template>
      </el-table-column>
      <el-table-column label="Status" min-width="130px" prop="status">
        <template v-slot="{ row }">
          <el-dropdown
            trigger="click"
            class="dropdown"
            @command="UpdateAdminStatus(row._id, $event)"
          >
            <p class="underline cursor-pointer">
              {{ row.isActive ? "Active" : "In-active" }}
            </p>
            <el-dropdown-menu>
              <el-dropdown-item command="Active">Active</el-dropdown-item>
              <el-dropdown-item command="In-active">In-active</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
      <el-table-column
        label="Actions"
        min-width="100px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="edit_role(scope.row)"
            ></feather-icon>
            <!-- <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class=""
              @click="handleDelete(scope)"
            ></feather-icon> -->
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column label="Action" min-width="180px" prop="action" sortable>
         <template v-slot="{ row }">
          <div class="flex items-center">
            <feather-icon
              icon="EditIcon"
              @click="editform(row)"
              class="mr-2 cursor-pointer"
            />
             <feather-icon
              icon="Trash2Icon"
              class="cursor-pointer"
              @click="deleteUser(row.userId)"
            /> 
          </div>
        </template>
      </el-table-column> -->
    </el-table>

    <!-- </el-table> -->

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        @change="handlePageChange"
        v-model="currentPage"
        :per-page="10"
        :total="user.totalCount"
      ></base-pagination>
      <!-- <b-pagination
        @change="handlePageChange"
        pills
        v-model="currentPage"
        :total-rows="total_row"
        :per-page="perPage"
        size="lg"
        class="ml-auto flex flex-wrap"
      ></b-pagination> -->
    </b-card-footer>
  </b-card>
</template>
<script>
// import ViewProfile from "./components/ViewProfile.vue";
import "../../scss/Index.scss";
// import CategoryData from "./components/CategoryData";
import InfoForm from "./components/InfoForm";
import editRole from "./components/EditUserRole";
import { mapState } from "vuex";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  data() {
    return {
      // CategoryData,

      currentPage: 1,
      perPage: 5,
      isViewDetails: false,
      editModal: false,
      editformModal: false,
      userData: {},
      singleUserData: {},
      userId: "",
      userToggle: false,
      editRole: false,
      // projects: "",
      search: "",
      // user: [],
    };
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    InfoForm,
    editRole,
    // ViewProfile,
  },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        this.getUsers();
      }, 500),
    },
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async handlePageChange(value) {
      this.currentPage = value;
      let payload = {
        limit: 10,
        offset: (this.currentPage - 1) * 10,
      };
      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("admin/getUsers", payload);
        if (data.code == 200) {
          loader.close();
          // return data.data.result;
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async UpdateAdminStatus(id, status) {
      const payload = {
        _id: id,
      };
      let loader = this.$loading();
      try {
        let data;
        if (status == "Active") {
          data = await this.$store.dispatch("eLearning/userActive", payload);
        } else if (status == "In-active") {
          data = await this.$store.dispatch("eLearning/userInactive", payload);
        }
        if (data.code == 200) {
          this.getUsers();
        }
      } catch (err) {
        loader.close();
        console.log(err);
      }
    },
    // async dataload() {
    //   let limit = this.perPage;
    //   // this.$store.dispatch("admin/getUsers");

    //   if ((this.currentPage - 1) * this.perPage > this.user.result.length)
    //     limit = this.currentPage * this.perPage - this.user.result.length;

    //   const offset = this.user.result.length;

    //   // console.log(this.user[limit])
    //   if (
    //     !this.user.result[this.currentPage * this.perPage - 1] &&
    //     this.total_row !== this.user.result.length
    //   ) {
    //     // let loader = this.$loading();
    //     try {
    //       const result = await this.$store.dispatch("admin/getUsers", {
    //         offset: offset,
    //         limit: limit,
    //       });
    //       this.total_row = this.$store.state.admin.user.totalCount;
    //       this.$store.state.admin.user.result.forEach((data) => {
    //         this.user[this.user.result.length] = data;
    //       });
    //       // this.user.push();
    //       loader.close();
    //     } catch (error) {
    //       loader.close();
    //     }
    //   }
    // },

    edit_role(data) {
      this.toggleEditRole(true);
      this.singleUserData = data;
    },
    async toggleEditRole(val = false) {
      this.editRole = val;
      // console.log({ id: this.userId, tf: this.editRole });
      if (!val) {
        await this.getUsers();
      }
    },

    async getAllStudents() {
      try {
        const data = await this.$store.dispatch("student/getStudents");
        // console.log(data);
        if (data.code == 200) {
          this.$store.commit("student/SET_STUDENT_DETAIL", data);
        }
        // console.log(this.students);
      } catch (error) {
        console.log(error);
      }
    },
    async editform(row) {
      this.editformModal = true;
      const data = await this.$store.dispatch("eLearning/getProfile", {
        userId: row._id,
      });
    },
    deleteUser(user) {
      return new Promise(async (resolve, reject) => {
        try {
          const result = await this.deleteAlert();
          if (result.isConfirmed) {
            let loader = this.$loading();
            const data = await this.$store.dispatch("eLearning/deleteUser", {
              _id: user.id,
            });

            this.$swal("Deleted!", "User has been deleted.", "success");
            loader.close();
            resolve(data);
          }
        } catch (err) {
          reject(err);
          loader.close();
        }
      });
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",

        text: "You won't be able to revert this!",

        icon: "warning",

        showCancelButton: true,

        confirmButtonColor: "#830c81",

        cancelButtonColor: "#d33",

        confirmButtonText: "Yes, delete it!",
      });
    },
    handleRoute(name, data) {
      this.$router.push({ name: name });
      this.$store.commit("auth/SET_SELECTED_USER", data);
    },
    // async fetchData() {
    //   const response = await this.$store.dispatch("admin/getUsers");
    //   console.log(response.data.result);
    //   return response.data.result;
    // },
    async fetchData() {
      let payload = {};

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("admin/getUsers", payload);
        if (data.code == 200) {
          loader.close();
          return data.data.result;
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async getUsers() {
      let payload = {
        limit: 10,
      };
      // console.log(this.search);
      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      // console.log(payload);

      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("admin/getUsers", payload);
        if (data.code == 200) {
          loader.close();
          // return data.data.result;
        }
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
  },
  async mounted() {
    await this.getAllStudents();
    // this.$store.dispatch("admin/getUsers");
    await this.getUsers();
  },
  computed: {
    displayedPages() {
      return this.user.result.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    total_row() {
      return this.user.result.length;
    },
    ...mapState("student", ["students"]),

    ...mapState("admin", { user: "user" }),
    selectedData() {
      return this.user.result;
    },
    json_fields() {
      return {
        first_name: "firstname",
        last_name: "lastname",
        mobile_no: "mobile",
        email_id: "email",
        user_type: "role",
        created_at: {
          field: "createdAt",
          callback: (date) => {
            return new Date(date).toDateString();
          },
        },
        // view_details: "details",
      };
    },
  },
};
</script>
